import { percentageOf } from '../../../utils/math';
import { isInPeriod } from '../../../utils/date';
import moment from 'moment';

export const PERIOD_OPTIONS = [
  //This are options for validate and calculate the period in the code
  { value: 'year', label: 'Este año' },
  { value: 'pastYear', label: 'Año pasado' },
  { value: 'month', label: 'Este mes' },
  { value: 'pastMonth', label: 'Mes pasado' },
  { value: 'period', label: 'Este periodo' },
  { value: 'pastPeriod', label: 'Periodo pasado' },
  { value: 'week', label: 'Esta semana' },
  { value: 'historic', label: 'Histórico' }
];

export const PERIOD_OPTIONS_MONTHLY = [
  //This is used only to show the options conditionally for "monthly" companies
  { value: 'year', label: 'Este año' },
  { value: 'pastYear', label: 'Año pasado' },
  { value: 'month', label: 'Este mes' },
  { value: 'pastMonth', label: 'Mes pasado' },
  { value: 'week', label: 'Esta semana' },
  { value: 'historic', label: 'Histórico' }
];

export const PERIOD_OPTIONS_DEFERRED = [
  //This is used only to show the options conditionally for "monthly (deferred)" companies
  { value: 'year', label: 'Este año' },
  { value: 'pastYear', label: 'Año pasado' },
  { value: 'period', label: 'Este periodo' },
  { value: 'pastPeriod', label: 'Periodo pasado' },
  { value: 'week', label: 'Esta semana' },
  { value: 'historic', label: 'Histórico' }
];

export const byLabel = ({ label }) => label;
